import { NgModule } from '@angular/core';
import { HtmlToTextPipe } from './html-to-text/html-to-text.pipe';
import { SafeHtmlPipe } from './safe-html/safe-html.pipe';
import { ReversePipe } from './reverse-pipe';
import { OperatorChatMessageFormatPipe } from './operator-chat-message-formatting.pipe';
import { CharacterGrouperPipe } from '../filters/character-grouper/character-grouper.filter';
import { ElapsedPipe } from './elapsed/elapsed.pipe';
import { IsFocusableTabIndexPipe } from './is-focusable-tab-index/is-focusable-tab-index.pipe';
import { MdToHtmlPipe } from 'shared/pipes/markdown/md-to-html/md-to-html.pipe';

@NgModule({
  declarations: [
    HtmlToTextPipe,
    OperatorChatMessageFormatPipe,
    ReversePipe,
    SafeHtmlPipe,
    CharacterGrouperPipe,
    ElapsedPipe,
    IsFocusableTabIndexPipe,
    MdToHtmlPipe
  ],
  exports: [
    HtmlToTextPipe,
    OperatorChatMessageFormatPipe,
    ReversePipe,
    SafeHtmlPipe,
    CharacterGrouperPipe,
    ElapsedPipe,
    IsFocusableTabIndexPipe,
    MdToHtmlPipe
  ]
})
export class CustomPipesModule {}
